import { LocalDate } from "@js-joda/core";
import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../../../core/api/queries";
import { ProcessJobId } from "../../../../shared/schema/schema";

export type ProcessType = "BANKED_MINUTES" | "AUTH_FILE" | "AR_NOTES";

export default createQueryGroup(({ api }) => ({
  jobs: (query: { processType: ProcessType; from: LocalDate; to: LocalDate }) => {
    return queryOptions({
      queryKey: ["process_jobs", "jobs", query],
      queryFn: () => api.get("./process_jobs", { query }),
      placeholderData: keepPreviousData,
    });
  },
  jobItems: (jobId: ProcessJobId) => {
    return queryOptions({
      queryKey: ["process_jobs", "jobs", jobId, "items"],
      queryFn: () => api.get("./process_jobs/:jobId/items", { path: { jobId } }),
      placeholderData: keepPreviousData,
    });
  },
}));
